import { NavLink } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import InstagramIcon from "@/assets/svg/InstagramIcon";
import LinkedinIcon from "@/assets/svg/LinkedinIcon";
import FacebookIcon from "@/assets/svg/FacebookIcon";
import XIcon from "@/assets/svg/XIcon";
import MailBoxIcon from "@/assets/svg/MailBoxIcon";
import LocationIcon from "@/assets/svg/LocationIcon";

import {
  COMPANY_LINKS,
  MAIL_TO,
  SOCIAL_LINKS
} from "@/constants/miscConstants";
import { useTranslation } from "react-i18next";
import SearchInputWithButton from "../SearchInputWithButton";
import { getConfig } from "@/get-config";

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  const { cdnAssetUrl } = getConfig();

  return (
    <footer className="bg-slate-100/50  static top-[100vh] ">
      <div className="mx-auto w-full max-w-screen-xl py-6 lg:py-8 px-4 md:px-5 ">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 gap-y-12 ">
          <div className="lg:col-span-2 m-auto text-center md:text-start md:m-0">
            <NavLink to="/">
              <div className="flex text-center ">
                <img
                  className="object-cover"
                  src={`${cdnAssetUrl}logoDashboard.svg`}
                  alt="Logo"
                  loading="lazy"
                />
              </div>
            </NavLink>
            <ul className="text-secondary text-sm font-normal ">
              <li className="text-xs md:text-sm my-4">
                <span>{t("footer.tagline")}</span>
              </li>
              <li className="mt-4 text-xl font-semibold text-secondary">
                {t("footer.subscribeNewsletter")}
              </li>
              <li className="static">
                <SearchInputWithButton
                  placeholder={t("footer.joinNowPlaceholder")}
                  btnText={t("common.joinNow")}
                  isBackground={true}
                  readOnly={true}
                  parentClassName="max-w-xl"
                />
              </li>
            </ul>
          </div>

          <div className=" px-0 xl:px-20 md:flex flex-col">
            <h2 className="mb-6 text-2xl text-secondary font-medium">
              {t("footer.company")}
            </h2>
            <ul className="text-gray-500 dark:text-gray-400">
              {COMPANY_LINKS?.map(({ to, title }) => (
                <li
                  className="mb-4 last:mb-0 text-secondary text-sm"
                  key={uuidv4()}>
                  <NavLink to={to}>{t(title)}</NavLink>
                </li>
              ))}
            </ul>
          </div>

          <div className=" px-0 xl:px-20 md:flex flex-col">
            <h2 className="mb-6 text-2xl text-secondary font-medium">
              {t("footer.headOffice")}
            </h2>

            <div className="text-gray-500 dark:text-gray-400 flex flex-col flex-1 justify-between">
              <ul>
                <li className="mb-3 text-base">
                  <div className="flex items-center">
                    <div>
                      <LocationIcon />
                    </div>
                    <span className="ml-2 text-secondary">
                      {t("footer.footerLocation")}
                    </span>
                  </div>
                </li>
                <li className="mb-4 text-base">
                  <div className="flex items-center">
                    <div>
                      <MailBoxIcon />
                    </div>
                    <NavLink
                      target="_blank"
                      rel="noreferrer"
                      className="ml-2 text-secondary"
                      to={MAIL_TO.footer}>
                      {t("footer.footerEmail")}
                    </NavLink>
                  </div>
                </li>
              </ul>
              <ul>
                <li>
                  <h2 className="text-2xl font-medium text-secondary">
                    {t("footer.followUsOn")}
                  </h2>
                </li>
                <div className="flex mt-2">
                  <li>
                    <a
                      href={SOCIAL_LINKS.instagram}
                      target="_blank"
                      rel="noreferrer">
                      <InstagramIcon bgColor="#31493C" />
                    </a>
                  </li>
                  <li className="mx-2">
                    <a
                      href={SOCIAL_LINKS.facebook}
                      target="_blank"
                      rel="noreferrer">
                      <FacebookIcon bgColor="#31493C" />
                    </a>
                  </li>
                  <li>
                    <a
                      href={SOCIAL_LINKS.linkedin}
                      target="_blank"
                      rel="noreferrer">
                      <LinkedinIcon bgColor="#31493C" />
                    </a>
                  </li>
                  <li className="mx-2">
                    <a
                      href={SOCIAL_LINKS.twitter}
                      target="_blank"
                      rel="noreferrer">
                      <XIcon bgColor="#31493C" />
                    </a>
                  </li>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* copy right section */}
      <div className="bg-secondary2 p-8">
        <div className="mx-auto w-full max-w-screen-xl flex justify-center items-center ">
          <div className="text-slate-100 text-xs md:text-sm">
            {t("footer.copyRight")} &nbsp;{year} &copy; &nbsp; HomesGlobe |
            &nbsp;
            {t("footer.allRightsReserved")}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
